import { Phone, Mail, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { EnquiryForm } from "./EnquiryForm";
import { Footer } from "./Footer";

const ContactDetails = () => (
  <div className="mt-14 space-y-6 text-lg md:text-xl font-light">
    <a
      href="tel:+61400105941"
      data-testid="contact-phone-link"
      className="flex items-center gap-4 hover:text-[#CFAEA5] transition-colors duration-300"
    >
      <Phone size={18} strokeWidth={1.5} className="text-[#CFAEA5]" />
      0400 105 941
    </a>
    <a
      href="mailto:cmorrison@montelklending.com.au"
      data-testid="contact-email-link"
      className="flex items-center gap-4 hover:text-[#CFAEA5] transition-colors duration-300 break-all"
    >
      <Mail size={18} strokeWidth={1.5} className="text-[#CFAEA5]" />
      cmorrison@montelklending.com.au
    </a>
    <p className="flex items-start gap-4 text-[#908B85] text-base">
      <MapPin size={18} strokeWidth={1.5} className="text-[#CFAEA5] mt-1 shrink-0" />
      Mobile broker — servicing clients Australia wide
    </p>
  </div>
);

export const Contact = () => (
  <section
    id="contact"
    data-testid="contact-section"
    className="pt-32 md:pt-48 bg-[#F1EAE1] border-t border-black/[0.06]"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-24 pb-32 md:pb-44">
        <div className="md:col-span-5">
          <Reveal>
            <p
              data-testid="contact-overline"
              className="text-xs font-semibold tracking-[0.35em] uppercase text-[#CFAEA5] mb-8"
            >
              Enquiries
            </p>
            <h2
              data-testid="contact-heading"
              className="font-display font-medium tracking-tight leading-[0.95] text-6xl sm:text-7xl lg:text-8xl"
            >
              Let's <em className="italic text-[#CFAEA5]">talk.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <ContactDetails />
          </Reveal>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <Reveal delay={0.2}>
            <EnquiryForm />
          </Reveal>
        </div>
      </div>
    </div>
    <Footer />
  </section>
);
